module.exports = __webpack_public_path__ + "media/images/country_flags/xk-8dd283bceccca95a48d84e68643dc712.png";